<template>
    <Mz-Dialog class="dialog" :title="title" width="3222px" :visible.sync="visible" @handleClose="handleClose">
        <div slot="content" class="main" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)">
            
                <table class="mytable">
                    <tr>
                        <th style="width:300px"></th>
                        <th>品牌</th>
                        <th>所属企业</th>
                        <th>成立时间</th>
                        <th>门店数量</th>
                    </tr>
                    <tr v-for="item in data.teas" :key="item.brand">
                        <td>{{item.sort}}</td>
                        <td>{{item.brand}}</td>
                        <td>{{item.company}}</td>
                        <td>{{item.time}}</td>
                        <td>{{item.number}}</td>
                    </tr>
                </table>
            </div>
    </Mz-Dialog>
</template>

<script>
import echarts from 'echarts'
import 'echarts/map/js/china'
    export default {
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            data: {
                type: Object,
                default: {}
            },
        },
        data() {
            return {
                loading: false
            }
        },
        created() {
            this.data.teas.sort((a, b) => a.sort - b.sort);
        },
        mounted() {
        },
        methods: {
            handleClose(){
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style lang="less" scoped>
@import '@/styles/common';
.main{
    padding: 85px 110px 115px 100px;
    // height: 1800px;
    .mytable{
        th{
            height: 144px;
            text-align: center;
        }
        td{
            text-align: center;
            padding: 30px 40px;
        }
        .td1{
            line-height: 84px;
        }
        .logobox{
            display: inline-block;
            position: relative;
            margin-left: 40px;
            .logo{
                display: inline-block;
                vertical-align: top;
                width: 84px;
                height: 84px;
                cursor: pointer;
            }
            .mypopper{
                border: 3px solid #2C5377;
                background: #05152de6;
                padding: 40px;
                color: #fff;
                position: absolute;
                left: 84px;
                top: -3px;
                z-index: 1;
                width: 1200px;
                .pop_content{
                    font-size: 36px;
                    line-height: 55px;
                    white-space: pre-wrap;
                    text-align: left;
                }
            }
        }
        .link{
            color: #fff;
        }
        .link:hover{
            color: #fff;
            text-decoration: underline;
        }
    }
}
</style>